import { render, staticRenderFns } from "./UserSegments.vue?vue&type=template&id=fb4eb236"
import script from "./UserSegments.vue?vue&type=script&lang=js"
export * from "./UserSegments.vue?vue&type=script&lang=js"
import style0 from "./UserSegments.vue?vue&type=style&index=0&id=fb4eb236&prod&lang=scss"
import style1 from "./UserSegments.vue?vue&type=style&index=1&id=fb4eb236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports